import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=ef9c5bfa&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=js&"
export * from "./NewsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9c5bfa",
  null
  
)

export default component.exports